WiseMetering.Views.DisableSite = WiseMetering.Views.Modal.Custom.extend({
    template: 'templates/sites/disable_site',
    title: () => i18next.t('modal.title.sites.disable'),
    buttons: ['yes', 'cancel'],
    className: 'mbx-info',

    yes: function() {
        this.model.disable().done(function() {
            this.collection.remove(this.model);
            this.close();
        }.bind(this));
    }
});
